<template>
  <v-app :class="getTheme">
    <Navigation
      v-if="isAuthenticated"
      class="hide-on-mobile"
      :items="items"
    ></Navigation>
    <v-main
      id="appp"
      class="main-content"
      :class="{ withMargin: isAuthenticated }"
    >
      <router-view></router-view>
    </v-main>
    <MobileNavigationTop v-if="isAuthenticated" :items="items" />
    <MobileNavigationBottom v-if="isAuthenticated" />
    <v-snackbar
      elevation="0"
      v-model="snackbar.value"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      right
      >{{ snackbar.text }}</v-snackbar
    >
    <Loader v-if="loading" />
  </v-app>
</template>

<script>
import Navigation from "./components/Navigation";
import MobileNavigationTop from "./components/MobileNavigationTop.vue";
import MobileNavigationBottom from "./components/MobileNavigationBottom.vue";
import Loader from "./components/Loader";
import en from "./assets/langs/en.json";
import srb from "./assets/langs/srb.json";
import { mapState, mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {}
  },
  components: {
    MobileNavigationTop,
    MobileNavigationBottom,
    Navigation,
    Loader,
  },
  computed: {
    ...mapState(["snackbar", "token", "loading", "drawerMenu"]),
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters(["isAuthenticated"]),
    getTheme() {
      if (this.$route.name == "Login" || this.$route.name == "DemoProfile") {
        return localStorage.getItem("theme") || "no-theme";
      }
      return this?.currentUser?.theme || localStorage.getItem("theme") || 'no-theme';
    },
    pageIsLogin() {
      return (
        this.$route.fullPath == "/Login?state=login" ||
        this.$route.name == "ForgotPassword"
      );
    },
    lang() {
      return this.$store.state.langObj || {};
    },
    items() {
      return [
        {
          icon: "mdi-home-outline",
          title: this.lang.menuLinks.myMemories,
          link: "/MyMemories",
          show: true,
        },
        {
          icon: "mdi-wall",
          title: this.lang.menuLinks.memoriesWall,
          link: "/MemoriesWall",
          show: true,
        },
        {
          icon: "mdi-bookmark",
          title: this.lang.menuLinks.bookmarks,
          link: "/Bookmarks",
          show: true,
        },
        {
          icon: "mdi-account-plus-outline",
          title: this.lang.menuLinks.addMemories,
          link: "/AddMemories",
          show: true,
        },
        {
          icon: "mdi-flag-outline",
          title: this.lang.menuLinks.reports,
          link: "/Reports",
          show: this.currentUser?.role == "Admin" || false,
        },
        {
          icon: "mdi-account-group-outline",
          title: this.lang.menuLinks.pendingRequests,
          link: "/PendingRequests",
          show: true,
        },
        // todo uncomment when it is ready
        // {
        //   icon: "mdi-chart-bar",
        //   title: this.lang.menuLinks.statistics,
        //   link: "/Statistics",
        //   show: true,
        // },
        {
          icon: "mdi-cog",
          title: this.lang.menuLinks.settings,
          link: "/Settings",
          show: true,
        },
        {
          icon: "mdi-logout",
          title: this.lang.menuLinks.logout,
          link: "/",
          show: true,
        },
      ];
    },
  },
  beforeMount() {
    var switchLang = localStorage.getItem("lang") || this.$store.state.lang;
    switch (switchLang) {
      case "en":
        this.$store.state.langObj = en;
        break;
      case "srb":
        this.$store.state.langObj = srb;
        break;
      default:
        this.$store.state.langObj = en;
        break;
    }

    // var color = "#3093a5";
    // switch (this.getTheme) {
    //   case "no-theme":
    //   case "theme-default":
    //     color = "#3093a5";
    //     break;
    //   case "theme-black":
    //     color = "#3093a5";
    //     break;
    //   case "theme-blue-gray":
    //     color = "#607D8B";
    //     break;
    //   case "theme-blue":
    //     color = "#1E88E5";
    //     break;
    //   case "theme-cyan":
    //     color = "#00B8D4";
    //     break;
    //   case "theme-dark-red":
    //     color = "#D50000";
    //     break;
    //   case "theme-green":
    //     color = "#64DD17";
    //     break;
    //   case "theme-light-green":
    //     color = "#00C853";
    //     break;
    //   case "theme-light-brown":
    //     color = "#8D6E63";
    //     break;
    //   case "theme-lime-dark":
    //     color = "#9E9D24";
    //     break;
    //   case "theme-orange":
    //     color = "#F57C00";
    //     break;
    //   case "theme-pink":
    //     color = "#FF4081";
    //     break;
    //   case "theme-light-purple":
    //     color = "#E040FB";
    //     break;
    //   case "theme-purple":
    //     color = "#800080";
    //     break;
    // }

    // document
    //   .querySelector('meta[name="theme-color"]')
    //   ?.setAttribute("content", color);
  },
  // methods: {
  //   closeSnackbar() {
  //     this.value = false;
  //   }
  // },
  // mounted () {
  //   this.value = true;
  // },
  // watch: {
  //   value(newValue) {
  //     if (newValue) {
  //       setTimeout(() => {
  //         this.value = false;
  //       }, 3000);
  //     }
  //   }
  // },
  watch: {
    "$store.state.lang": {
      handler: function (newValue) {
        switch (newValue) {
          case "en":
            this.$store.state.langObj = en;
            localStorage.setItem("lang", "en");
            break;
          case "srb":
            this.$store.state.langObj = srb;
            localStorage.setItem("lang", "srb");
            break;
          default:
            this.$store.state.langObj = en;
            localStorage.setItem("lang", "en");
            break;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "assets/scss/main.scss";
// .gc-snackbar {
//   position: fixed;
//   justify-content: space-between;
//   bottom: 15px;
//   right: 15px;
//   background: #000;
//   border-radius: 8px;
//   padding: 12px;
//   box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
//   z-index: 9999;
//   max-width: 400px;
//   min-width: 300px;
//   display: flex;
//   align-items: center;
//   p {
//     margin-bottom: 0;
//     font-size: 14px;
//     color: #fff;
//     margin-right: 15px;
//   }
//   .v-icon {
//     color: #fff;
//     cursor: pointer;
//   }
// }
</style>
